import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextareaAutosize,
  Divider,
} from "@mui/material";
import "./Modal.module.scss";
import { IconButton } from "cprime-foundational-components";
import Button from "../Common/CprimeButton";
import CloseIcon from "@mui/icons-material/Close";

interface ConfirmModalProps {
  value: string;
  limitmessage: string;
  modalMessage: string;
  isOpen: boolean;
  headLabel: string;
  handleClose: () => void;
  handleConfirm: () => void;
  cancelButtonLabel: string;
  confirmButtonStyle?:
    "primary" | "secondary" | "tertiary" | "ghost" | "danger";
  confirmButtonLabel: string;
  handleTextFeild: (value: string) => void;
  deleteModal?: boolean;
  confirmButtonDisabled?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = React.memo(
  ({
    value,
    limitmessage,
    modalMessage,
    isOpen,
    headLabel,
    handleClose,
    handleConfirm,
    cancelButtonLabel,
    confirmButtonStyle = "primary",
    confirmButtonLabel,
    handleTextFeild,
    deleteModal,
    confirmButtonDisabled = false,
  }) => {
    return (
      <Dialog
        open={isOpen}
        // onClose={handleClose}
        style={{ minWidth: "850px" }}
      >
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: "600",
          }}
        >
          <span>{headLabel}</span>{" "}
          <IconButton onClick={handleClose} data-testid="closemodal">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent style={{ padding: "0" }}>
          {!deleteModal && (
            <div style={{ padding: "0 24px 16px 24px" }}>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  width: "550px",
                  color: "#000000",
                }}
              >
                {modalMessage}
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "12px",
                  marginTop: "32px",
                }}
              >
                <div>
                  {limitmessage}
                  {confirmButtonLabel === "Deny" ||
                  confirmButtonLabel === "Revoke" ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : (
                    <></>
                  )}
                </div>
                <div>{value?.length}/500</div>
              </div>
              <TextareaAutosize
                minRows={3}
                style={{ borderRadius: "5px", width: "100%" }}
                onChange={(e) => {
                  if (e?.target?.value?.length <= 500) {
                    handleTextFeild(e.target.value);
                  }
                }}
                value={value}
              ></TextareaAutosize>
            </div>
          )}

          <Divider />
          <DialogActions
            sx={{
              padding: "16px 24px",
            }}
          >
            <Button onClick={handleClose} variant="tertiary">
              {cancelButtonLabel}
            </Button>
            <Button
              onClick={handleConfirm}
              disabled={
                confirmButtonDisabled ||
                ((confirmButtonLabel?.toLowerCase() === "deny" ||
                  confirmButtonLabel?.toLowerCase() === "revoke") &&
                value?.length < 1
                  ? true
                  : false)
              }
              variant={confirmButtonStyle}
            >
              {confirmButtonLabel}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    );
  },
);

export default ConfirmModal;
